<template>
  <section class="app-main">
    <div class="app-main-scrollbar">
      <div class="app-main-container">
        <keep-alive v-if="keepAlive">
          <router-view :key="key" />
        </keep-alive>
        <router-view v-if="!keepAlive" :key="key" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    },
    keepAlive() {
      return !!this.$route.meta.keepAlive
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  //width: 100%;
  width: calc(100% - 80px);
  position: fixed;
  background: rgba(241, 242, 243, 0.5);
  bottom: 0px;
  z-index:0;
  .app-main-scrollbar {
    position: relative;
    height: 100%;
    width: 100%;
    overflow:auto;
  }
  .app-main-container {
    border: 12px solid #f1f2f3;
    min-height: calc(100vh - 85px);
    height: 100%;
    background: #fff;
    width: 100%;
    overflow-y: auto;
  }
}

// .fixed-header+.app-main {
//   padding-top: 50px;
// }

.hasTagsView {
  // .app-main {
  //   /* 84 = navbar + tags-view = 50 + 34 */
  //   min-height: calc(100vh - 84px);
  // }

  .fixed-header+.app-main {
    top: 84px;
  }
}
</style>

<style lang="scss">
// .el-popup-parent--hidden {
//   .fixed-header {
//     padding-right: 15px;
//   }
// }
</style>
